import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { t } from 'i18next';
import { ReactComponent as ArrowLeftIcon } from '../icons/arrow.left.svg';
import { ReactComponent as XmarkCircleIcon } from '../icons/xmark.circle.svg';
import addUserProfileV1 from '../components/api/mutations/addUserProfileV1';

const nicknamePlaceholder = t('nicknameSettingPage.placeholder');

export default function NicknameSettingPage() {
  const [input, setInput] = useState('');
  const navigate = useNavigate();
  const location = useLocation();

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => setInput(e.target.value);

  const onBackClick = () => {
    if (location.key !== 'default') {
      navigate(-1);
    } else {
      return;
    }
  };

  const clearInput = () => {
    setInput('');
  };

  // 닉네임 수정
  const postNicknameSetting = async () => {
    const responseBase = await addUserProfileV1('base', input, null);
    const responseTrading = await addUserProfileV1('trading', input, null);
    const dataBase = await responseBase.json();
    const dataTrading = await responseTrading.json();

    if (responseBase.status < 300 && dataBase && responseTrading.status < 300 && dataTrading) {
      // 닉네임 설정 후 환영 페이지 + 검색 페이지
      navigate('/welcome?init=true', {
        state: {
          redirectUrl: '/search-artists'
        },
        replace: true
      });
    } else {
      alert(t('nicknameSettingPage.nickFailedAlert'));
    }
  };

  return (
    <div className="flex flex-col h-screen items-center w-[100vw] max-w-[570px] pt-[env(safe-area-inset-top)] pb-[env(safe-area-inset-bottom)]">
      <button
        className="mt-[14px] px-[16px] mb-[15px] w-full z-50 justify-start"
        onClick={onBackClick}
        type="button"
      >
        <ArrowLeftIcon className="fill-black dark:fill-white" />
      </button>
      <div className="flex flex-col items-center w-[100vw] max-w-[570px] px-[24px]">
        <div className="flex flex-col mt-[12px] w-full py-">
          <span className="text-left text-[24px] font-bold line-height-[120%]">
            {t('nicknameSettingPage.title')}
          </span>
          <span className="text-main-light-4 leading-[20px] dark:text-main-dark-4 mt-2 text-[15px] break-keep">
            {t('nicknameSettingPage.description')}
          </span>
        </div>
        <div className="relative mt-[34px] w-full">
          <input
            type="text"
            value={input}
            onChange={handleInputChange}
            placeholder={nicknamePlaceholder}
            className="
              w-full
              bg-secondary-light dark:bg-secondary-dark
              hover:bg-secondary-light dark:hover:bg-secondary-dark
              rounded-[12px]
              py-[14px] px-[16px]
              text-gray-900 dark:text-gray-100
              placeholder-gray-400 dark:placeholder-gray-500
              focus:outline-none focus:ring-2 focus:ring-primary-light dark:focus:ring-primary-dark
              border
              border-transparent
            "
          />
          {input && (
            <button
              type="button"
              onClick={clearInput}
              className="
                  absolute right-[16px] top-1/2
                  -translate-y-1/2
                  w-[24px] h-[24px]
                  flex items-center justify-center
                "
            >
              <XmarkCircleIcon fill="gray" width={24} height={24} />
            </button>
          )}
        </div>
        <div className="mt-auto w-full max-w-[570px] absolute bottom-[5%] px-[24px]">
          <button
            className={`
            text-white ${
              input !== ''
                ? 'bg-primary-light dark:bg-primary-dark text-white'
                : 'bg-disabled-light dark:bg-disabled-dark text-onDisabled-light dark:text-onDisabled-dark'
            }
            flex items-center justify-center
            w-full      
            font-bold
            text-[16px]
            text-center
            rounded-[56px]
            disabled:opacity-50
            min-h-[52px]
          `}
            onClick={postNicknameSetting}
            type="button"
          >
            {t('next')}
          </button>
        </div>
      </div>
    </div>
  );
}

